var _excluded = ["activeMonth", "toggleYearSelection"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { forwardRef } from 'react';
import { Icon } from '../../../../../foundations/Icon';
import { useIntl } from '../../../../../theme/i18n';
import { useMultiStyleConfig } from '../../../../../utils/use-style-config';
import { Text } from '../../../../dataDisplay';
import { Box } from '../../..';
import { useCalendarContext } from '../../CalendarContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var YearSelectionHeaderTrigger = /*#__PURE__*/forwardRef((_ref, ref) => {
  var {
    activeMonth,
    toggleYearSelection
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var {
    size,
    isMobileDatePicker,
    showYearSelection
  } = useCalendarContext();
  var {
    formatDate
  } = useIntl();
  var title = formatDate(activeMonth.date, {
    month: 'long',
    year: 'numeric'
  });
  var styles = useMultiStyleConfig('_BaseCalendar', {
    isMobileDatePicker,
    size
  });
  return /*#__PURE__*/_jsxs(Box, _objectSpread(_objectSpread({
    as: "button",
    "aria-expanded": showYearSelection,
    __css: styles['yearSelectionHeaderTrigger'],
    onClick: toggleYearSelection,
    ref: ref,
    "aria-label": "".concat(title, ", Change month or year button")
  }, props), {}, {
    children: [/*#__PURE__*/_jsx(Text, {
      as: "h2",
      textStyle: "body2Semi",
      "aria-hidden": true,
      children: title
    }), /*#__PURE__*/_jsx(Icon, {
      type: showYearSelection ? 'caret-up' : 'caret-down',
      size: "large",
      color: "inherit",
      "aria-hidden": true
    })]
  }));
});
YearSelectionHeaderTrigger.displayName = 'YearSelectionHeaderTrigger';
//# sourceMappingURL=YearSelectionHeaderTrigger.js.map